
    <div *ngIf="modal" id="my-modal" class="c-modal" >
      <div class="modal-area card">
      <div class="m-custom-content">

          <div class="">
      <div class="m-title">Your enquiry was successful!!</div>
      <div class="modal-text mdt ">
          Your query has successfully reached us, Our Support team will contact you in a while. Sit back and relax.
      </div>
      <div class="text-center">
          <button (click)="modal=false" class="  enq-button bg-pink px-20" type="submit">ok</button>
      </div>
          </div>
          <div class="">
      <img src="/assets/modalhero.svg" class="img-fluid" alt="">
          </div>
      </div>
      </div>
          </div>


          <app-sidebar></app-sidebar>

            <div class="content-container">
              <div class="container-fluid   y form-container ">

                  <div class="title ">
                      Connect Us
                  </div>
        <!--  -->
        <div class="col-lg-10 mx-auto pt-5 pt-lg-5 card">

          <div  role="form" class="">
            <div class="form-row  forms-style">
              <div class="col-lg-6 col-xl-5 form-group">
                  <label>
                      Enter your name
                  </label>
                <input type="text" name="name" class="bg-gray form-control bg-gray" id="name" placeholder="" data-msg="Please enter at least 4 chars" />
                <div class=""></div>
              </div>
              <div class="col-lg-6 col-xl-5 form-group">
                  <label for="">Contact number</label>
                <input type="" class="bg-gray form-control" name="" id="" placeholder=""   />
                <div class=""></div>
              </div>
            </div>
            <div class="form-row forms-style">
              <div class="col-lg-6 col-xl-5 form-group">
                  <label for="">
                      Email ID
                  </label>
                <input type="text" name="" class="bg-gray form-control" id="" placeholder=""  />
                <div class=""></div>
              </div>
              <div class="col-lg-6 col-xl-5  form-group">
                  <label for="">
                      Location
                  </label>
                <input type="" class="bg-gray form-control" name="" id="" placeholder=""   />
                <div class=""></div>
              </div>
            </div>

            <div class="form-group ">
                <label for="">
                  Write to us
                </label>
              <textarea class="bg-gray form-control" name="message" rows="5"   placeholder="enter your text here"></textarea>
              <div class=""></div>
            </div>

            <div class="text-center"><button class="  enq-button bg-pink" (click)="modal=true">Send Message</button></div>
          </div>

        </div>




      <!--  -->
      </div>


